import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import axios from "axios";
import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Typography } from "@mui/material";
import { koKRGrid } from "../../component/common/TableKRText";
import CustomPagination from "../../component/common/CustomPagination";
import { useNavigate } from "react-router-dom";

function CustomToolbar(props: any) {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      />
      <GridToolbarQuickFilter sx={{ marginLeft: "auto" }} />
    </GridToolbarContainer>
  );
}

const columns: GridColDef[] = [
  {
    field: "id",
    headerName: "id",
    width: 70,
  },
  { field: "mgm_pk", headerName: "MGM_PK", width: 230 },
  { field: "gub_age", headerName: "나이대", width: 70 },
  { field: "gub_sbj", headerName: "sub_sbj", width: 75 },
  { field: "rec_ymd", headerName: "녹음일자", width: 130 },
  { field: "seq", headerName: "일련번호", width: 270 },
];

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface rowDetailType {
  id: number;
  mgm_pk: string;
  gub_age: string;
  gub_sbj: string;
  rec_ymd: string;
  seq: string;
}
export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const PrcWrd = () => {
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);

  const nav = useNavigate();
  const [rowDetail, setRowDetail] = useState<rowDetailType>({
    id: 0,
    mgm_pk: "",
    gub_age: "",
    gub_sbj: "",
    rec_ymd: "",
    seq: "",
  });

  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  const getAuth = async () => {
    var result = await axios.get("http://localhost:9680/prcWrdList", {
      params: { page: page },
      withCredentials: true,
    });

    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        id: idx + 1,
        mgm_pk: data.mgm_pk,
        gub_age: data.gub_age,
        gub_sbj: data.gub_sbj,
        rec_ymd: data.rec_ymd,
        seq: data.seq,
      };
    });

    setRows(datas);

    setPagination(result.data.pagination);
  };

  useEffect(() => {
    getAuth();
  }, [page]);

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  function CustomFooter() {
    // console.log("CustomFooter pagination", pagination);
    return (
      <GridFooterContainer sx={{ display: "flex", justifyContent: "center" }}>
        {pagination !== undefined ? (
          <CustomPagination pagination={pagination} goPage={goPage} />
        ) : ""}
      </GridFooterContainer>
    );
  }

  const goDetail = (event: any) => {
    console.log("event", event);

    nav(event.row.mgm_pk);
    //http://localhost:3000/insight/work01/prcWrd/10_11_2004_220810_0001
  };

  return (
    <React.Fragment>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        단어 가공 목록
      </Typography>

      <ThemeProvider theme={theme}>
        <div style={{ height: "85vh", width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            checkboxSelection
            components={{ Toolbar: CustomToolbar, Footer: CustomFooter }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            getRowId={(row) => row.id}
            onRowDoubleClick={(e) => goDetail(e)}
            localeText={koKRGrid}
          />
        </div>
      </ThemeProvider>
    </React.Fragment>
  );
};
export default PrcWrd;
